/**
 * @file index.tsx
 *
 * @fileoverview Shows information about the organization (about and benefits).
 */

import { useContext } from 'react';
import { OrganizationLocationsWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/Locations/Empty';
import { OrganizationLocationsWidgetView } from '~/jobiqo/components/Organization/Widgets/Locations/View';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

const KEY = 'locations';

export interface OrganizationLocationsWidgetProps {
  organization: OrganizationProfile;
}

export const OrganizationLocationsWidget = ({
  organization,
}: OrganizationLocationsWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (
    !organization?.organizationLocation?.lat &&
    !organization?.organizationLocation?.lon &&
    (!organization.furtherLocations ||
      organization.furtherLocations.length === 0)
  ) {
    return userContext.user && organization.canEdit ? (
      <OrganizationLocationsWidgetEmpty
        organization={organization}
        boxId={KEY}
      />
    ) : null;
  } else {
    return (
      <OrganizationLocationsWidgetView
        organization={organization}
        boxId={KEY}
      />
    );
  }
};
export default OrganizationLocationsWidget;
